export default {
    common: {
        active: 'Active',
        inactive: 'Inactive',
        select: 'Select…',
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        loading: 'Loading…'
    },
    PhoneInput: {
        selectCountryCode: 'Indicatif',
        placeholder: 'Saisir le numero de telephone'
    },
    Settings: {
        General: {
            logoHint: 'Veuillez téléverser un logo carré (par ex. 256x256 ou 512x512).',
            logoPreview: 'Aperçu du logo',
            logoUploading: 'Téléversement du logo...',
            logoUploaded: 'Logo téléversé.',
            logoUploadError: 'Échec du téléversement du logo.',
            logoUploadCta: 'Changer le logo',
            notificationEmail: 'E-mail de notification',
            notificationEmailPlaceholder: 'Saisir l’e-mail de notification',
            address: 'Adresse',
            addressPlaceholder: 'Saisir l’adresse',
            country: 'Pays',
            selectCountry: 'Choisir un pays',
            phone: 'Telephone',
            phonePlaceholder: 'Saisir le numero de telephone',
            phoneCountry: 'Pays du telephone',
            website: 'Site web',
            websitePlaceholder: 'Saisir le site web',
            email: 'E-mail de l’entreprise',
            emailPlaceholder: 'Saisir l’e-mail de l’entreprise'
        },
        Billing: {
            billingEmail: 'E-mail de facturation',
            billingEmailPlaceholder: 'Saisir l’e-mail de facturation',
            saveBillingEmail: 'Enregistrer l’e-mail de facturation',
            billingEmailSaved: 'E-mail de facturation enregistré.',
            billingEmailError: 'Échec de l’enregistrement de l’e-mail de facturation',
            enterCard: 'Ajoutez une carte pour activer la facturation.',
            loadingPaymentForm: 'Chargement du formulaire de paiement...',
            missingPublishableKey: 'Cle publique Stripe manquante.',
            saveCard: 'Enregistrer la carte',
            savingCard: 'Enregistrement...',
            cardSaved: 'Carte enregistrée.',
            cardError: 'Echec de l’enregistrement de la carte',
            setupIntentError: 'Impossible de demarrer la configuration de la carte'
        }
    },
    Dashboard: {
        title: 'Dashboard',
        loading: 'Chargement...',
        error: 'Erreur lors du chargement du tableau de bord',
        setup_title: 'Finaliser la configuration de l’entreprise',
        setup_upload_logo_title: 'Télécharger le logo de l’entreprise',
        setup_upload_logo_desc: 'Ajoutez un logo pour afficher votre marque partout.',
        setup_upload_logo_cta: 'Ajouter un logo',
        setup_add_description_title: 'Ajouter une description',
        setup_add_description_desc: 'Expliquez aux partenaires et utilisateurs ce que vous faites.',
        setup_add_description_cta: 'Ajouter une description',
        setup_add_address_title: 'Compléter l’adresse',
        setup_add_address_desc: 'Ajoutez l’adresse et le pays de l’entreprise.',
        setup_add_address_cta: 'Ajouter une adresse',
        setup_add_contact_title: 'Ajouter des contacts',
        setup_add_contact_desc: 'Renseignez un e-mail et un téléphone pour le support et la facturation.',
        setup_add_contact_cta: 'Ajouter des contacts',
        setup_add_website_title: 'Ajouter le site web',
        setup_add_website_desc: 'Partagez votre site officiel avec clients et partenaires.',
        setup_add_website_cta: 'Ajouter un site',
        setup_set_localization_title: 'Définir la localisation',
        setup_set_localization_desc: 'Choisissez devise, fuseau horaire et langue pour les rapports.',
        setup_set_localization_cta: 'Définir la localisation',
        setup_add_billing_email_title: 'Ajouter l’e-mail de facturation',
        setup_add_billing_email_desc: 'Assurez-vous que les factures arrivent dans la bonne boîte.',
        setup_add_billing_email_cta: 'Ajouter l’e-mail de facturation',
        setup_add_venue_title: 'Creer votre premier site',
        setup_add_venue_desc: 'Ajoutez un site pour commencer a importer des produits.',
        setup_add_venue_cta: 'Creer un site',
        setup_loyalty_points_title: 'Definir les points de fidelite',
        setup_loyalty_points_desc: 'Definissez combien de points les clients gagnent par achat.',
        setup_loyalty_points_cta: 'Configurer les points',
        average_revenue_per_user: 'Revenu moyen par utilisateur',
        average_selling_transaction_value: 'Valeur moyenne des ventes',
        belonging_users_count: 'Utilisateurs rattachés',
        campaigns_count: 'Campagnes',
        manufacturer_count: 'Fabricants',
        revenue_value: 'Revenus',
        selling_transactions_count: 'Transactions de vente',
        sold_items_count: 'Articles vendus',
        total_transaction_volume: 'Volume total des transactions',
        users_count: 'Utilisateurs',
        venues_count: 'Sites'
    },
    DistributorRetailers: {
        title: 'Retail partners',
        subtitle: 'Understand which retailers rely on you for each brand/category.',
        loading: 'Loading retailers...',
        error: 'Unable to load retailers.',
        searchPlaceholder: 'Search retailers…',
        list: {
            title: 'Retailer overview'
        },
        tabs: {
            list: 'Overview',
            graph: 'Timeline'
        },
        stats: {
            totalRetailers: 'Total retailers',
            outboundValue: 'Outbound value',
            outboundQuantity: 'Outbound units'
        },
        table: {
            title: 'Retailers',
            count: '{{count}} total',
            retailer: 'Retailer',
            manufacturers: 'Manufacturers',
            outbound: 'Outbound',
            categories: 'Categories',
            units: '{{count}} units',
            allCategories: 'All categories',
            view: 'View'
        },
        pagination: {
            prev: 'Prev',
            next: 'Next'
        },
        graph: {
            period: 'Period',
            retailers: 'Retailers',
            allRetailers: 'All retailers',
            noData: 'No timeline data yet.',
            error: 'Unable to load timeline data.',
            periodOption: {
                yesterday: 'Yesterday',
                last_7_days: 'Last 7 days',
                this_month: 'This month',
                this_quarter: 'This quarter',
                this_year: 'This year'
            }
        }
    },
    DistributorRetailerDetail: {
        loading: 'Loading retailer detail…',
        error: 'Unable to load retailer detail.',
        subtitle: 'No description provided',
        back: 'Back to retailers',
        metrics: {
            outboundValue: 'Outbound value',
            outboundQuantity: 'Outbound units',
            manufacturers: 'Linked manufacturers'
        },
        manufacturers: 'Manufacturers & categories',
        recentOrders: 'Recent orders',
        empty: 'No data yet.'
    },
    DistributorManufacturers: {
        title: 'Partner manufacturers',
        subtitle: 'Monitor connected brands, inbound supply, and sell-through performance.',
        loading: 'Loading manufacturers...',
        error: 'Unable to load manufacturers.',
        searchPlaceholder: 'Search manufacturers…',
        stats: {
            totalManufacturers: 'Total linked manufacturers',
            inboundValue: 'Inbound value',
            outboundValue: 'Outbound value'
        },
        table: {
            title: 'Manufacturers',
            count: '{{count}} total',
            manufacturer: 'Manufacturer',
            inbound: 'Inbound',
            outbound: 'Outbound',
            retailers: 'Active retailers',
            units: '{{count}} units',
            view: 'View'
        },
        periodOption: {
            last_7_days: 'Last 7 days',
            this_month: 'This month',
            this_quarter: 'This quarter',
            this_year: 'This year'
        },
        list: {
            title: 'Manufacturer overview'
        },
        pagination: {
            prev: 'Prev',
            next: 'Next'
        }
    },
    DistributorManufacturerDetail: {
        loading: 'Loading manufacturer detail…',
        error: 'Unable to load manufacturer detail.',
        subtitle: 'No description provided',
        back: 'Back to manufacturers',
        metrics: {
            inboundValue: 'Inbound value',
            inboundQuantity: 'Inbound units',
            outboundValue: 'Outbound value',
            outboundQuantity: 'Outbound units',
            activeRetailers: 'Active retailers'
        },
        topRetailers: 'Top retailers',
        recentActivity: 'Recent activity',
        empty: 'No data yet.',
        activity: {
            outbound: 'Outbound',
            inbound: 'Inbound'
        }
    },
    LoginPage: {
        title: 'Bon retour',
        subtitle: 'Accédez aux garanties, à la fidélité et aux analyses avec un seul identifiant.',
        email_label: 'Email',
        password_label: 'Mot de passe',
        login_button: 'Connexion',
        login_error: 'Échec de la connexion. Vérifiez votre email et mot de passe.',
        register: "S'enregistrer",
        no_account: "Pas de compte ?",
        forgot_password: 'Mot de passe oublié'
    },
    RegisterPage: {
        "title": "Enregistrer une entreprise",
        "subtitle": "Créez votre compte entreprise en quelques minutes.",
        "company_name": "Nom de l'entreprise",
        "company_type": "Type d'entreprise",
        "currency": "Devise",
        "select_type": "Sélectionner le type",
        "select_currency": "Sélectionner la devise",
        "select_required": "Veuillez sélectionner le type d'entreprise et la devise.",
        "admin_name": "Prénom de l'administrateur",
        "admin_surname": "Nom de famille de l'administrateur",
        "admin_email": "E-mail de l'administrateur",
        "password": "Mot de passe",
        "password_repeat": "Répéter le mot de passe",
                "field_required": "Ce champ est obligatoire.",
        "fix_required": "Veuillez remplir tous les champs obligatoires.",
        "passwords_mismatch": "Les mots de passe ne correspondent pas.",
        "registration_failed": "Échec de l'inscription. Veuillez vérifier le formulaire et réessayer.",
        "submit": "S'enregistrer",
        "registering": "Enregistrement...",
        "back_to_login": "Retour à la connexion"
    },
    email: "Email",
    password: "Mot de passe",
    submit: "Soumettre",
    error: "Email ou mot de passe incorrect.",
    ManufacturerNav: {
        dashboard: 'Tableau de bord',
        products: 'Produits',
        retailers: 'Détaillants',
        distributors: 'Distributeurs',
        venues: 'Venues',
        transactions: 'Transactions',
        warranties: 'Warranties',
        support: 'Support',
        integrations: 'Intégrations',
        imports: 'Imports/Exports',
        compliance: 'Conformité',
        settings: 'Paramètres',
        logout: 'Déconnexion'
    },
    ManufacturerTransactions: {
        title: 'Transactions',
        subtitle: 'Analyze sell-in vs sell-through across retailers, venues, and SKUs.',
        tabs: {
            overview: 'Overview',
            statistics: 'Statistics',
            progress: 'Progress'
        },
        cards: {
            sellIn: 'Sell-in value',
            sellThrough: 'Sell-through value',
            retailers: 'Retail partners',
            venues: 'Active venues',
            buyers: 'Distinct buyers',
            transactions: 'Transactions',
            units: '{{count}} units'
        },
        table: {
            columns: {
                date: 'Date',
                retailer: 'Retailer',
                venue: 'Venue',
                sellInValue: 'Sell-in value',
                sellThroughValue: 'Sell-through value',
                transactions: 'Transactions'
            }
        },
        statistics: {
            gender: 'Buyer gender distribution',
            age: 'Buyer age groups',
            countries: 'Buyer countries',
            venues: 'Venue contribution',
            buyers: 'Buyers'
        },
        progress: {
            sellThrough: 'Sell-through comparison',
            current: 'Current period',
            previous: 'Previous period'
        },
        errors: {
            loadStats: 'Unable to load transactions.',
            loadDemographics: 'Unable to load statistics.',
            loadProgress: 'Unable to load progress data.'
        }
    },
    ManufacturerDashboard: {
        title: 'Tableau de bord Fabricant',
        loading: 'Chargement des statistiques fabricant...',
        error: 'Impossible de charger le tableau de bord fabricant.',
        totalSkus: 'Total des SKU',
        activeDistributors: 'Distributeurs actifs',
        sellThrough: 'Valeur Sell-Through',
        sellIn: 'Valeur Sell-In',
        activeRetailers: 'Détaillants actifs',
        returns: 'Retours',
        activeWarranties: 'Garanties actives',
        campaignsRunning: 'Campagnes en cours',
        avgSellThrough: 'Valeur moyenne Sell-Through',
        sellThroughRate: 'Taux Sell-Through',
        sellInQuantity: 'Unités Sell-In',
        sellThroughQuantity: 'Unités Sell-Through',
        sellInTransactions: 'Transactions Sell-In',
        sellThroughTransactions: 'Transactions Sell-Through',
        uniqueBuyers: 'Acheteurs uniques',
        warrantyActivation: 'Taux d’activation de garantie',
        openTickets: 'Tickets de service ouverts',
        returnsRate: 'Taux de retours',
        avgTtr: 'Temps moyen de réparation',
        topSkus: 'Meilleurs SKU',
        topRetailers: 'Meilleurs détaillants',
        topUserRegions: 'Meilleures régions (clients)',
        topRetailerRegions: 'Meilleures régions (détaillants)',
        topBuyers: 'Meilleurs acheteurs',
        actions: 'Actions recommandées',
        noActions: 'Aucune action immédiate requise.'
    },
    ManufacturerProducts: {
        title: 'Catalogue produits',
        subtitle: 'Gérez vos SKU et suivez le sell-in/sell-through.',
        tabs: {
            catalog: 'Catalogue',
            transactions: 'Transactions'
        },
        searchPlaceholder: 'Rechercher par SKU ou nom...',
        newProduct: 'Nouveau produit',
        table: {
            columns: {
                product: 'Produit',
                sku: 'SKU',
                sellIn: 'Unités Sell-In',
                sellThrough: 'Unités Sell-Through',
                sellThroughValue: 'Valeur Sell-Through',
                actions: 'Actions'
            },
            view: 'Voir'
        },
        create: {
            title: 'Créer un produit',
            fields: {
                product_name: 'Nom du produit',
                model_number: 'Référence',
                description: 'Description',
                release_year: 'Année de sortie',
                warranty_duration: 'Durée de garantie (mois)',
                warranty_coverage: 'Couverture de garantie',
                documentation_url: 'URL documentation',
                initial_price: 'Prix initial (€)'
            },
            cancel: 'Annuler',
            save: 'Enregistrer',
            saving: 'Enregistrement...'
        },
        notifications: {
            created: 'Produit créé avec succès.'
        },
        transactions: {
            title: 'Transactions Fabricant',
            subtitle: 'Sell-in et sell-through par période.',
            retailers: 'Détaillants',
            customers: 'Clients'
        },
        detail: {
            back: 'Retour',
            cards: {
                sellInUnits: 'Unités Sell-In',
                sellInValue: 'Valeur Sell-In',
                sellThroughUnits: 'Unités Sell-Through',
                sellThroughValue: 'Valeur Sell-Through'
            },
            insights: 'Analyses de ventes',
            sellInSeries: 'Qté Sell-In',
            sellThroughSeries: 'Qté Sell-Through',
            topRetailers: 'Meilleurs détaillants',
            topUserRegions: 'Meilleures régions (clients)',
            topRetailerRegions: 'Meilleures régions (détaillants)',
            topBuyers: 'Meilleurs acheteurs',
            transactions: 'Résumé des transactions',
            periodNote: 'Filtré par période',
            transactions_retailers: 'Détaillants',
            transactions_distributors: 'Distributeurs',
            transactions_customers: 'Clients',
            units: '{{count}} unités',
            noTransactions: 'Aucune transaction pour cette période.',
            variants: 'Variantes',
            variantModel: 'Modèle',
            variantSku: 'SKU',
            variantAttributes: 'Attributs',
            noVariants: 'Aucune variante pour le moment.',
            identifiers: 'Identifiants',
            identifierType: 'Type',
            identifierValue: 'Valeur',
            identifierSku: 'SKU',
            noIdentifiers: 'Aucun identifiant pour le moment.'
        },
        errors: {
            fetchFailed: 'Impossible de charger les produits.',
            createFailed: 'Échec de création du produit.'
        }
    },
    ManufacturerRetailers: {
        title: 'Retail partners',
        subtitle: 'Monitor who buys from you, how they perform, and drill into transaction trends.',
        tabs: {
            list: 'Retailers',
            graph: 'Retailers Graph',
            venues: 'Venues'
        },
        table: {
            search: 'Search retailers...',
            view: 'Open',
            columns: {
                retailer: 'Retailer',
                inventory: 'Units in stock',
                sold: 'Units sold',
                sellInValue: 'Buy value',
                sellThroughValue: 'Sell value',
                venues: 'Venues',
                action: 'Action'
            }
        },
        graph: {
            period: 'Period',
            retailers: 'Retailers',
            allRetailers: 'All retailers',
            noData: 'No activity recorded for the selected filters.',
            buyLabel: 'Retailers Buy',
            sellLabel: 'Retailers Sell',
            periodOption: {
                yesterday: 'Yesterday',
                last_7_days: 'Last 7 days',
                this_month: 'This Month',
                this_quarter: 'This Quarter',
                this_year: 'This Year'
            }
        },
        errors: {
            loadList: 'Unable to load retailers.',
            loadGraph: 'Unable to load graph data.'
        },
        venues: {
            search: 'Search venues or retailers...',
            columns: {
                venue: 'Venue',
                retailer: 'Retailer',
                location: 'Location',
                sellThroughValue: 'Sell-through value',
                lastActivity: 'Last activity'
            },
            errors: {
                loadList: 'Unable to load retailer venues.'
            }
        }
    },
    ManufacturerDistributors: {
        title: 'Distributeurs',
        subtitle: 'Suivez les partenaires amont, la couverture et la dynamique du canal.',
        tabs: {
            list: 'Liste',
            stats: 'Analyses'
        },
        table: {
            search: 'Rechercher des distributeurs...',
            view: 'Ouvrir',
            notAvailable: 'N/D',
            columns: {
                distributor: 'Distributeur',
                country: 'Pays',
                inventory: 'Unités en canal',
                sold: 'Unités vendues',
                inbound: 'Valeur entrante',
                outbound: 'Valeur sortante',
                venues: 'Sites',
                action: 'Action'
            }
        },
        stats: {
            loading: 'Chargement des analyses distributeurs...',
            error: 'Impossible de charger les analyses distributeurs.',
            cards: {
                distributors: 'Distributeurs actifs',
                inventory: 'Unités en canal',
                sold: 'Unités vendues',
                inbound: 'Valeur entrante',
                outbound: 'Valeur sortante',
                venues: 'Sites rattachés'
            },
            trend: {
                title: 'Tendance de valeur (EUR)',
                inbound: 'Entrant',
                outbound: 'Sortant',
                empty: 'Aucun mouvement cette semaine.'
            },
            countries: {
                title: 'Meilleurs pays',
                empty: 'Aucun pays disponible.'
            }
        },
        errors: {
            loadList: 'Impossible de charger les distributeurs.',
            loadStats: 'Impossible de charger les analyses distributeurs.'
        }
    },
    ManufacturerRetailerDetail: {
        back: 'Back to Retailers',
        subtitle: 'Full visibility into this retailer relationship.',
        loading: 'Loading retailer detail...',
        error: 'Unable to load retailer detail.',
        stats: {
            inventory: 'Units in stock',
            sold: 'Units sold',
            buyValue: 'Buy value',
            sellValue: 'Sell value',
            units: 'units'
        },
        contact: {
            title: 'Contacts & HQ',
            notAvailable: 'Not provided'
        },
        venues: {
            title: 'Venues',
            empty: 'No venues connected.'
        },
        items: {
            title: 'Manufacturer items performance',
            empty: 'No transactions recorded for this retailer.',
            columns: {
                product: 'Product',
                sku: 'SKU',
                purchased: 'Purchased',
                sold: 'Sold'
            }
        }
    },
    ManufacturerDistributorDetail: {
        back: 'Retour aux distributeurs',
        subtitle: 'Visibilité complète sur cette relation distributeur.',
        loading: 'Chargement du distributeur...',
        error: 'Impossible de charger le distributeur.',
        stats: {
            inventory: 'Unités en canal',
            sold: 'Unités vendues',
            inbound: 'Achats auprès du fabricant',
            outbound: 'Ventes aux partenaires',
            venues: 'Sites',
            units: 'unités'
        },
        contact: {
            title: 'Informations de contact',
            notAvailable: 'Non renseigné'
        },
        venues: {
            title: 'Sites',
            empty: 'Aucun site associé.'
        },
        activity: {
            title: 'Activité récente',
            empty: 'Aucune transaction récente.',
            columns: {
                date: 'Date',
                direction: 'Direction',
                quantity: 'Quantité',
                value: 'Valeur'
            },
            direction: {
                inbound: 'Entrant du fabricant',
                outbound: 'Sortant vers les partenaires'
            }
        }
    },
    ManufacturerSettings: {
        title: 'Paramètres fabricant',
        subtitle: 'Configurez l’escalade, les SLA, le branding et les API.',
        loading: 'Chargement des paramètres...',
        error: 'Impossible de charger les paramètres.',
        escalation: {
            title: 'Politique d’escalade & SLA',
            subtitle: 'Définissez qui est prévenu et les délais promis.',
            policy: 'Politique d’escalade',
            sla: 'SLA cible (heures)',
            slaPlaceholder: 'ex. 24',
            contacts: 'Contacts d’escalade',
            contactName: 'Nom',
            contactEmail: 'Email',
            contactPhone: 'Téléphone'
        },
        branding: {
            title: 'Branding & support',
            subtitle: 'Adaptez les couleurs du portail et les canaux support.',
            primary: 'Couleur principale',
            secondary: 'Couleur secondaire',
            logo: 'URL du logo',
            supportEmail: 'Email support',
            supportPhone: 'Téléphone support'
        },
        api: {
            title: 'Tokens API',
            subtitle: 'Gérez les identifiants REST pour vos intégrations.',
            key: 'Clé API actuelle',
            secret: 'Nouveau secret (copiez maintenant)',
            none: 'Non généré',
            active: 'API activée'
        },
        actions: {
            addContact: 'Ajouter un contact',
            remove: 'Supprimer',
            rotateToken: 'Régénérer le token',
            save: 'Enregistrer',
            saving: 'Enregistrement...',
            add: 'Ajouter'
        },
        toast: {
            saved: 'Paramètres enregistrés',
            error: 'Impossible d’enregistrer',
            token: 'Nouveau token API généré'
        }
    },
    ManufacturerIntegrations: {
        title: 'Intégrations',
        subtitle: 'Connectez vos ERP/POS/CRM et surveillez webhooks et accès.',
        loading: 'Chargement des intégrations...',
        error: 'Impossible de charger les intégrations.',
        stats: {
            total: 'Connecteurs',
            active: 'Actifs',
            webhook: 'Alertes webhook'
        },
        table: {
            name: 'Connecteur',
            type: 'Type',
            status: 'Statut',
            lastSync: 'Dernière synchro',
            webhook: 'Webhook',
            actions: 'Actions',
            never: 'Jamais'
        },
        status: {
            healthy: 'OK',
            warning: 'Alerte',
            stale: 'Ancien',
            inactive: 'Inactif'
        },
        webhook: {
            healthy: 'OK',
            stale: 'Ancien',
            missing: 'Manquant',
            failing: 'Erreur',
            unknown: 'Inconnu'
        },
        detail: {
            type: 'Type de connecteur',
            endpoint: 'URL API',
            sync: 'Fréquence',
            apiKey: 'Clé API',
            apiSecret: 'Secret API (à copier maintenant)',
            webhookUrl: 'URL webhook',
            webhookSecret: 'Secret webhook'
        },
        form: {
            name: 'Nom',
            type: 'Type',
            email: 'Email de contact',
            endpoint: 'URL endpoint',
            sync: 'Fréquence',
            syncRealtime: 'Temps réel',
            syncHourly: 'Horaire',
            syncDaily: 'Quotidien',
            webhook: 'URL webhook',
            isActive: 'Intégration active',
            custom: 'Personnalisé'
        },
        actions: {
            add: 'Ajouter un connecteur',
            cancel: 'Annuler',
            save: 'Enregistrer',
            saving: 'Enregistrement...',
            confirmDelete: 'Supprimer ce connecteur ?',
            testWebhook: 'Tester le webhook'
        },
        toast: {
            created: 'Connecteur créé',
            updated: 'Connecteur mis à jour',
            deleted: 'Connecteur supprimé',
            error: 'Échec de l’action',
            token: 'Identifiants API régénérés',
            webhook: 'Test webhook enregistré',
            secret: 'Copiez ce secret API maintenant'
        },
        editTitle: 'Modifier le connecteur',
        addTitle: 'Ajouter un connecteur'
    },
    ManufacturerImportExport: {
        title: 'Imports / Exports',
        subtitle: 'Gérez les catalogues SKU, garanties et mappings distributeurs.',
        loading: 'Chargement des tâches...',
        error: 'Impossible de charger les tâches d’import/export.',
        tabs: {
            imports: 'Imports',
            exports: 'Exports',
        },
        types: {
            sku: 'Catalogue SKU',
            warranty: 'Modèles de garantie',
            distributor: 'Mappings distributeurs',
        },
        form: {
            type: 'Type',
            sourceName: 'Nom de la source',
            sourceUrl: 'URL de la source',
            fileName: 'Nom du fichier (optionnel)',
        },
        imports: {
            requestTitle: 'Lancer un import',
            requestSubtitle: 'Déposez vos fichiers CSV/JSON via un lien sécurisé.',
        },
        exports: {
            requestTitle: 'Planifier un export',
            requestSubtitle: 'Générez des fichiers pour vos systèmes partenaires.',
        },
        actions: {
            startImport: 'Démarrer l’import',
            startExport: 'Démarrer l’export',
            submitting: 'Envoi...',
        },
        table: {
            type: 'Type',
            source: 'Source',
            status: 'Statut',
            progress: 'Progression',
            date: 'Date',
            file: 'Fichier',
            download: 'Télécharger',
        },
        status: {
            pending: 'En attente',
            processing: 'En cours',
            completed: 'Terminé',
            failed: 'Échec',
        },
        history: {
            imports: 'Historique des imports',
            exports: 'Historique des exports',
        },
        toast: {
            importCreated: 'Import lancé',
            exportCreated: 'Export demandé',
            error: 'Échec de l’opération',
        },
    },
    ManufacturerCompliance: {
        title: 'Conformité & certificats',
        subtitle: 'Suivez les DPP, documents réglementaires et alertes d’expiration.',
        loading: 'Chargement des documents...',
        error: 'Impossible de charger les documents.',
        types: {
            dpp: 'DPP',
            regulatory: 'Réglementaire',
            certificate: 'Certificat',
        },
        form: {
            type: 'Type de document',
            title: 'Titre',
            description: 'Description',
            file: 'URL du fichier',
            expires: 'Date d’expiration',
        },
        table: {
            doc: 'Document',
            type: 'Type',
            expires: 'Expire',
            status: 'Statut',
            actions: 'Actions',
        },
        status: {
            draft: 'Brouillon',
            shared: 'Partagé',
        },
        alerts: {
            expiring: '{{count}} document(s) expirent dans 30 jours',
        },
        actions: {
            add: 'Ajouter un document',
            save: 'Enregistrer',
            saving: 'Enregistrement...',
            cancel: 'Annuler',
            edit: 'Modifier',
            share: 'Partager',
            confirmDelete: 'Supprimer ce document ?',
        },
        share: {
            title: 'Partager le document',
            description: 'Saisissez des emails séparés par des virgules.',
            placeholder: 'partner@example.com',
        },
        toast: {
            created: 'Document ajouté',
            updated: 'Document mis à jour',
            deleted: 'Document supprimé',
            shared: 'Document partagé',
            error: 'Échec de l’opération',
        },
    },
    ManufacturerVenues: {
        title: 'Manufacturer Venues',
        subtitle: 'Manage your own venue footprint and monitor sell-through per location.',
        table: {
            search: 'Search venues...',
            view: 'Open',
            columns: {
                venue: 'Venue',
                location: 'Location',
                sellThroughValue: 'Sell-through value',
                lastActivity: 'Last activity',
                action: 'Action'
            }
        },
        errors: {
            loadList: 'Unable to load venues.'
        },
        create: {
            button: 'New Venue',
            title: 'Add Venue',
            fields: {
                name: 'Venue name',
                city: 'City',
                address: 'Address',
                email: 'Email',
                phone: 'Phone',
                website: 'Website',
                description: 'Description'
            },
            cancel: 'Cancel',
            save: 'Create Venue',
            saving: 'Saving...',
            success: 'Venue created successfully.',
            error: 'Unable to create venue.',
            errors: {
                nameRequired: 'Name is required.'
            }
        }
    },
    ManufacturerVenueDetail: {
        back: 'Back to Venues',
        subtitle: 'Performance overview for {{city}} showroom',
        loading: 'Loading venue detail...',
        error: 'Unable to load venue detail.',
        stats: {
            sellIn: 'Sell-in value',
            sellThrough: 'Sell-through value',
            units: 'units'
        },
        contact: {
            title: 'Contact & location'
        },
        lastActivity: 'Last activity: {{date}}',
        topItems: {
            title: 'Top items',
            empty: 'No items sold yet.',
            metrics: '{{sell}} units • {{value}}'
        }
    },
    ManufacturerWarranties: {
        title: 'Warranties',
        subtitle: 'Define warranty templates and track active coverage for your products.',
        stats: {
            templates: 'Templates',
            active: 'Active warranties',
            expiring: 'Expiring (30d)'
        },
        tabs: {
            templates: 'Templates',
            active: 'Active warranties'
        },
        table: {
            template: 'Template',
            duration: 'Duration',
            type: 'Type',
            status: 'Status',
            actions: 'Actions',
            months: 'months',
            searchPlaceholder: 'Search templates...'
        },
        actions: {
            newTemplate: 'New template'
        },
        modal: {
            createTitle: 'Create warranty template',
            editTitle: 'Edit warranty template',
            fields: {
                name: 'Name',
                duration: 'Duration (months)',
                type: 'Template type',
                category: 'Category',
                item: 'Specific SKU',
                anyItem: 'Any item',
                description: 'Description',
                terms: 'Terms (one per line)',
                claimProcess: 'Claim process (one per line)',
                active: 'Active'
            }
        },
        active: {
            item: 'Item',
            serial: 'Serial',
            buyer: 'Buyer',
            activated: 'Activated',
            expires: 'Expires'
        },
        notifications: {
            created: 'Template created.',
            updated: 'Template updated.',
            deleted: 'Template deleted.'
        },
        errors: {
            loadStats: 'Unable to load warranty stats.',
            loadTemplates: 'Unable to load templates.',
            saveTemplate: 'Unable to save template.',
            deleteTemplate: 'Unable to delete template.',
            loadFormMeta: 'Unable to load form data.',
            loadActive: 'Unable to load active warranties.'
        },
        confirmDelete: 'Delete this template?'
    },
    DistributorDashboard: {
        title: 'Distributor Dashboard',
        loading: 'Loading distributor metrics...',
        error: 'Unable to load distributor dashboard.',
        metrics: {
            activeManufacturers: 'Active Manufacturers',
            activeRetailers: 'Active Retailers',
            activeVenues: 'Active Logistics Hubs',
            skuPortfolio: 'SKU Portfolio',
            inboundValue: 'Inbound Value',
            inboundQuantity: 'Inbound Quantity',
            outboundValue: 'Outbound Value',
            outboundQuantity: 'Outbound Quantity',
            inventoryOnHand: 'Inventory On Hand',
            orderFillRate: 'Order Fill Rate',
            averageFulfillmentTime: 'Avg. Fulfillment Time',
            returnsRate: 'Returns Rate',
            openSupportCases: 'Open Support Cases',
            integrationAlerts: 'Integration Alerts',
            campaignsSupported: 'Campaigns Supported'
        },
        insights: {
            topManufacturers: 'Top Manufacturers',
            topRetailers: 'Top Retailers',
            topRegions: 'Top Regions',
            actionItems: 'Action Items',
            noActions: 'No pending actions'
        },
        sections: {
            network: {
                title: 'Channel coverage',
                copy: 'How many partners, venues, and SKUs you actively touch today.'
            },
            flow: {
                title: 'Flow performance',
                copy: 'Track the movement of units across inbound and outbound lanes, along with fulfillment pace.'
            },
            health: {
                title: 'Reliability & engagement',
                copy: 'Quality signals such as returns, support workload, integration alerts, and joint campaigns.'
            }
        },
        inventory: {
            title: 'Warehouse capacity',
            copy: 'Aggregated stock across every distributor hub.',
            inboundQuantity: 'Inbound quantity',
            outboundQuantity: 'Outbound quantity'
        }
    },
    DistributorNav: {
        manufacturers: 'Manufacturers',
        retailers: 'Retailers'
    },
    DistributorVenues: {
        title: 'Distributor Venues',
        subtitle: 'Track downstream locations supplied by your network.',
        errors: {
            loadList: 'Unable to load venues.'
        },
        table: {
            search: 'Search venues...',
            view: 'Open',
            count: '{{count}} total',
            columns: {
                venue: 'Venue',
                retailer: 'Retailer',
                location: 'Location',
                outboundValue: 'Outbound value',
                lastActivity: 'Last activity',
                action: 'Action'
            }
        }
    },
    DistributorVenueDetail: {
        back: 'Back to Venues',
        subtitle: 'Performance overview for {{city}} hub',
        loading: 'Loading venue detail...',
        error: 'Unable to load venue detail.',
        stats: {
            outbound: 'Outbound value',
            units: 'units'
        },
        topItems: {
            title: 'Top items',
            empty: 'No items shipped yet.',
            metrics: '{{quantity}} units • {{value}}'
        }
    },
    Campaigns: {
        title: 'Campagnes',
        name: 'Nom',
        description: 'Description',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        goalDescription: 'Description de l’objectif',
        budget: 'Budget',
        actions: 'Actions',
        edit: 'Modifier',
        delete: 'Supprimer',
        addNew: 'Ajouter une nouvelle campagne',
        search: 'Rechercher des campagnes...',
        noCampaigns: 'Aucune campagne trouvée.',
        Tutorial: {
            welcomeMessage: 'Bienvenue dans la gestion des campagnes !',
            createCampaignTitle: 'Créer une nouvelle campagne',
            createCampaignMessage: 'Ici, vous pouvez créer une nouvelle campagne pour vos besoins métier.',
            manageCampaignsTitle: 'Gérer vos campagnes',
            manageCampaignsMessage: 'Dans cette section, vous pouvez voir, modifier et supprimer vos campagnes existantes. Utilisez la recherche pour trouver rapidement une campagne.',
            tutorialTitle: 'Tutoriel des campagnes',
            tutorialMessage: 'Ce tutoriel vous guide pour gérer les campagnes efficacement.'
        },
        CampaignCreate: {
            title: 'Créer une nouvelle campagne',
            name: 'Nom de la campagne',
            description: 'Description',
            startDate: 'Date de début',
            endDate: 'Date de fin',
            budget: 'Budget'
        }
    }
};
